export default "__VITE_ASSET__DoaJ8uSx__"